import { modals } from '@mantine/modals';
import AuthStepEditDialog from './AuthStepEditDialog';

/**
 * If handleEditOperation is provided, it will be used to edit the operation.
 * Otherwise, it will add a new step that contains a new auth component operation.
 */
export function useAuthStepEdit({
  stepId,
  // Letting parent passing in the handleAddStep because it contains predefined handlers (e.g. onSettled handlers)
  handleAddStepWithHandlers,
  testContentId,
}: {
  stepId?: string;
  handleAddStepWithHandlers?: (step: {
    description: string;
    testAccountId?: string;
    operations: {
      order: number;
      operation: {
        operationType: string;
        componentId: string;
        testAccount: {
          id: string;
        };
      };
    }[];
  }) => Promise<void>;
  testContentId: string;
}) {
  return (selectedAccountId: string) => {
    modals.open({
      withCloseButton: false,
      size: 'sm',
      children: (
        <AuthStepEditDialog
          stepId={stepId}
          selectedAccountId={selectedAccountId}
          handleAddStep={handleAddStepWithHandlers}
          testContentId={testContentId}
        />
      ),
    });
  };
}
